/** ⚠️ COPY LOCKED — verbatim from manifesto.html. Do NOT modify. */
export interface Differential {
    num: string;
    title: string;
    body: string;
}

export const DIFFERENTIALS: Differential[] = [
    {
        num: '01',
        title: 'Value-Backed AI Transformation',
        body: 'Every initiative begins with a clear economic thesis—revenue growth, operational efficiency, customer experience improvement, or productivity gains—with defined value metrics from day one.',
    },
    {
        num: '02',
        title: 'From Data Readiness to AI Readiness',
        body: 'We structure data ecosystems so they are reliable, governed, integrated, and genuinely prepared to power scalable AI systems—not just dashboards or storage layers.',
    },
    {
        num: '03',
        title: 'Revenue & Efficiency Use Cases, Prioritized',
        body: 'We design and prioritize AI use cases based on measurable impact on growth, margin, personalization, hyperpersonalization, cost reduction, and operational efficiency.',
    },
    {
        num: '04',
        title: 'Architecture Before Automation',
        body: 'We build strong data and system foundations before deploying intelligent layers, reducing rework and accelerating sustainable value capture.',
    },
    {
        num: '05',
        title: 'Industrialization Over Pilots',
        body: 'We design AI initiatives for production from day one, ensuring governance, monitoring, adoption, and long-term scalability.',
    },
    {
        num: '06',
        title: 'Embedded Value Tracking',
        body: 'We implement structured mechanisms to measure ROI, savings, revenue uplift, NPS impact, and productivity gains throughout execution.',
    },
    {
        num: '07',
        title: 'Experience-Driven AI Design',
        body: 'We apply AI to enhance customer journeys, reduce friction, increase personalization, and create measurable improvements in customer satisfaction and loyalty.',
    },
    {
        num: '08',
        title: 'Productivity Amplification',
        body: 'We design agents and intelligent systems that eliminate repetitive work, accelerate decision-making, and increase enterprise productivity.',
    },
    {
        num: '09',
        title: 'Executive-Level Orchestration',
        body: 'We connect AI transformation to board-level priorities, aligning governance, risk management, and economic impact with enterprise strategy.',
    },
];
